import { Navigate } from 'react-router-dom';

import { useAdminUrlNavigation } from '../hooks/useAdminUrlNavigation';

export default function DashboardRootRedirect() {
  const { neutralDashboardPath } = useAdminUrlNavigation();

  return <Navigate to={neutralDashboardPath} replace />;
}
